export default "__VITE_ASSET__tU32vShk__"